import { Toaster as Sonner, toast } from "sonner"
import { useTheme } from "../../context/ThemeContext"

const Toaster = ({
  ...props
}) => {
  // Follow the app's theme so sonner renders light/dark to match.
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          // Match the app's green-tinted dark surfaces (not the default slate).
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-slate-900 group-[.toaster]:border-[#b8cf88] group-[.toaster]:shadow-lg dark:group-[.toaster]:bg-[#0f1810] dark:group-[.toaster]:text-slate-100 dark:group-[.toaster]:border-[#1e2d18]",
          description: "group-[.toast]:text-slate-500 dark:group-[.toast]:text-slate-400",
          actionButton:
            "group-[.toast]:bg-[#556B2F] group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-slate-100 group-[.toast]:text-slate-500 dark:group-[.toast]:bg-[#182213] dark:group-[.toast]:text-slate-300",
          closeButton:
            "group-[.toast]:bg-white group-[.toast]:text-slate-500 group-[.toast]:border-[#b8cf88] hover:group-[.toast]:bg-slate-100 dark:group-[.toast]:bg-[#182213] dark:group-[.toast]:text-slate-300 dark:group-[.toast]:border-[#1e2d18]",
          // Brand-tinted semantic accents so success/error fit the olive theme.
          success: "group-[.toast]:!text-[#3d4f22] dark:group-[.toast]:!text-[#b8cf88]",
          error: "group-[.toast]:!text-red-600 dark:group-[.toast]:!text-red-400",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
